import { Component, Input } from '@angular/core';
import {
  ComplianceData,
  ComplianceElement,
} from '../../../../shared/models/compliance-data.model';
import {
  COMMON_IMPORTS,
  MATERIAL_IMPORTS,
  PIPES_IMPORTS,
} from '../../../../shared/imports/common-imports';
import { ComplianceElementDetails } from '../../../../shared/models/compliance-element-details.enum';
import ComplianceElements from '../../../../shared/data/compliance-elements';
import { VendorFlagsPercentages } from '../../../../shared/models/percentages-response.model';

@Component({
  selector: 'app-list-view-item',
  standalone: true,
  imports: [MATERIAL_IMPORTS, COMMON_IMPORTS, PIPES_IMPORTS],
  templateUrl: './list-view-item.component.html',
  styleUrl: './list-view-item.component.scss',
})
export class ListViewItemComponent {
  @Input() element!: ComplianceData;
  viewTypes = ComplianceElementDetails;

  getFlagCount(elements: ComplianceElement[]) {
    const flags = [
      { key: 'red', count: 0 },
      { key: 'yellow', count: 0 },
      { key: 'green', count: 0 },
    ];

    const elemData = elements.find((element) => element.value > 0);

    if (elemData) {
      const fixedPercentages = this.fixPercentages(
        elemData.value,
        elemData.percentages,
      );

      flags[0].count = fixedPercentages.high;
      flags[1].count = fixedPercentages.medium;
      flags[2].count = fixedPercentages.low;
    }

    return flags;
  }

  fixPercentages(total: number, percentages: VendorFlagsPercentages) {
    const fixedPercentages = { high: 0, medium: 0, low: 0 };

    if (total === 0) {
      return fixedPercentages;
    }

    fixedPercentages.high = percentages.high;
    fixedPercentages.medium = percentages.medium;
    fixedPercentages.low = percentages.low;

    return fixedPercentages;
  }

  getScore(elements: ComplianceElement[]): number {
    if (elements.length === 0) {
      return 0;
    }

    return elements.reduce((sum, element) => sum + element.value, 0);
  }

  getDetailsLink(element: ComplianceElement): string {
    const complianceElements = ComplianceElements;

    const link = complianceElements.find(
      (el) => el.name === element.elementName,
    )?.link;
    return `/details/${this.element.therapeuticArea.id}/${link}`;
  }
}
